
import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/vehicleAccess',
    meta: { title: '车辆出入厂管理' },
    component: Layout,
    redirect: '/vehicleAccess/list',
    children: [
      {
        path: 'list',
        meta: { title: '车辆出入厂管理', activeMenu: '/vehicleAccess' },
        component: () => import('@/views/vehicleAccess/VehicleAccess.vue')
      },
      {
        path: 'detail',
        meta: { title: '车辆出入厂管理详情', activeMenu: '/vehicleAccess' },
        component: () => import('@/views/vehicleAccess/VehicleAccessDetail.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑车辆', activeMenu: '/vehicleAccess' },
        component: () => import('@/views/vehicleAccess/VehicleAccessAdd.vue')
      },
      {
        path: 'add',
        meta: { title: '新增车辆', activeMenu: '/vehicleAccess' },
        component: () => import('@/views/vehicleAccess/VehicleAccessAdd.vue')
      }

    ]
  }

]
